// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"BlogHero_heroContainer__a2QV4"};